import { render, staticRenderFns } from "./CrystalIcon.vue?vue&type=template&id=4f0a21e9&scoped=true"
import script from "./CrystalIcon.vue?vue&type=script&lang=js"
export * from "./CrystalIcon.vue?vue&type=script&lang=js"
import style0 from "./CrystalIcon.vue?vue&type=style&index=0&id=4f0a21e9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a21e9",
  null
  
)

export default component.exports